(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-testimonial-grid"] && !Shopify.designMode) return;
  try {
    
  function initCustomTestimonialsCarousel() {
    document.querySelectorAll('.custom-testimonials').forEach(function(section) {
      var track = section.querySelector('[data-testimonials-track]');
      var prev = section.querySelector('[data-testimonials-prev]');
      var next = section.querySelector('[data-testimonials-next]');

      if (!track || !prev || !next || track.dataset.carouselReady === 'true') {
        return;
      }

      track.dataset.carouselReady = 'true';

      var getStep = function() {
        var card = track.querySelector('.chichi-testimonial-card');
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;

        return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      };

      prev.addEventListener('click', function() {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      next.addEventListener('click', function() {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    });
  }

  initCustomTestimonialsCarousel();
  document.addEventListener('shopify:section:load', initCustomTestimonialsCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
